/** 登录后 / 菜单：未绑礼券时是否不再提醒（localStorage，按浏览器持久化） */
const SKIP_REMINDER_KEY = 'referral_bind_skip_reminder'

export const REFERRAL_BIND_STATUS_EVENT = 'referral-bind-status-changed'

export function isReferralBindReminderSkipped() {
  try {
    return localStorage.getItem(SKIP_REMINDER_KEY) === '1'
  } catch {
    return false
  }
}

export function setReferralBindReminderSkipped(skipped = true) {
  try {
    if (skipped) localStorage.setItem(SKIP_REMINDER_KEY, '1')
    else localStorage.removeItem(SKIP_REMINDER_KEY)
  } catch {
    // ignore
  }
  notifyReferralBindStatusChanged()
}

export function notifyReferralBindStatusChanged() {
  window.dispatchEvent(new Event(REFERRAL_BIND_STATUS_EVENT))
}

/** 是否应在菜单上显示「尚未绑券」提示 */
export async function shouldShowReferralBindMenuHint() {
  if (isReferralBindReminderSkipped()) return false
  try {
    const { fetchReferralBindStatus } = await import('@/utils/referralCoupon')
    const st = await fetchReferralBindStatus()
    return !st.hasBinding && st.canBind
  } catch {
    return false
  }
}
